(function () {
  var STORAGE_KEY = 'ovara_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    setWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) {
      return h !== handle;
    });
    setWishlist(list);
  }

  function syncButtons() {
    var buttons = document.querySelectorAll('.wishlist-toggle');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var active = isWishlisted(btn.dataset.productId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    updateHeaderCount();
  }

  function updateHeaderCount() {
    var countEl = document.getElementById('wishlist-header-count');
    if (!countEl) return;
    var count = getWishlist().length;
    if (count > 0) {
      countEl.textContent = count > 99 ? '99+' : String(count);
      countEl.hidden = false;
    } else {
      countEl.hidden = true;
    }
  }

  function moneyFormat(cents) {
    return 'Rs. ' + (cents / 100).toFixed(2);
  }

  function renderDrawer() {
    var contentEl = document.getElementById('wishlist-drawer-content');
    if (!contentEl) return;
    var handles = getWishlist();

    if (handles.length === 0) {
      contentEl.innerHTML = '<p class="wishlist-drawer__empty">Your wishlist is empty. Tap the heart on any product to save it here.</p>';
      return;
    }

    contentEl.innerHTML = '<p class="wishlist-drawer__empty">Loading...</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var html = '';
      products.forEach(function (product) {
        if (!product) return;
        var image = product.featured_image || (product.images && product.images[0]) || '';
        var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
        html +=
          '<div class="wishlist-drawer__item" data-handle="' + product.handle + '">' +
          '<img class="wishlist-drawer__item-image" src="' + image + '&width=144" alt="' + product.title + '" loading="lazy">' +
          '<div class="wishlist-drawer__item-info">' +
          '<a class="wishlist-drawer__item-title" href="/products/' + product.handle + '">' + product.title + '</a>' +
          '<div class="wishlist-drawer__item-price">' + moneyFormat(product.price) + '</div>' +
          '<div class="wishlist-drawer__item-actions">' +
          '<button type="button" class="wishlist-drawer__item-buy-now" data-variant-id="' + variantId + '">Buy Now</button>' +
          '<button type="button" class="wishlist-drawer__item-remove" data-handle="' + product.handle + '">Remove</button>' +
          '</div>' +
          '</div>' +
          '</div>';
      });
      contentEl.innerHTML = html || '<p class="wishlist-drawer__empty">Your wishlist is empty. Tap the heart on any product to save it here.</p>';
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    if (typeof drawer.showModal === 'function') {
      drawer.showModal();
    } else {
      drawer.setAttribute('open', '');
    }
    renderDrawer();
  }

  function closeDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      drawer.removeAttribute('open');
    }
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('.wishlist-toggle');
    if (toggleBtn) {
      e.preventDefault();
      var handle = toggleBtn.dataset.productId;
      var active = toggleWishlist(handle);
      var matches = document.querySelectorAll('.wishlist-toggle[data-product-id="' + handle + '"]');
      for (var i = 0; i < matches.length; i++) {
        matches[i].classList.toggle('is-active', active);
        matches[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      updateHeaderCount();
      if (active) {
        openDrawer();
      }
      return;
    }

    var buyNowBtn = e.target.closest('.wishlist-drawer__item-buy-now');
    if (buyNowBtn) {
      var variantId = buyNowBtn.dataset.variantId;
      if (!variantId) return;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'Buy Now';
        });
      return;
    }

    if (e.target.closest('#wishlist-header-button')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest('#wishlist-drawer-close')) {
      closeDrawer();
      return;
    }

    if (e.target.id === 'wishlist-drawer') {
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest('.wishlist-drawer__item-remove');
    if (removeBtn) {
      removeFromWishlist(removeBtn.dataset.handle);
      syncButtons();
      renderDrawer();
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
})();
